import * as React from 'react';

const LogoFacebookColorSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.999 12c0-5.524-4.477-10-10-10s-10 4.476-10 10c0 4.99 3.657 9.128 8.438 9.878V14.89h-2.54V12h2.54V9.795c0-2.506 1.493-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.772-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989c4.78-.75 8.437-4.887 8.437-9.879z"
            fill="#1877F2"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.892 14.89l.443-2.89h-2.774v-1.877c0-.79.388-1.561 1.63-1.561h1.261V6.1s-1.144-.195-2.238-.195c-2.284 0-3.777 1.384-3.777 3.89V12h-2.54v2.89h2.54v6.989a10.073 10.073 0 003.125 0V14.89h2.33z"
            fill="#fff"
        />
    </svg>
);

LogoFacebookColorSvg.displayName = 'LogoFacebookColorSvg';
export default LogoFacebookColorSvg;
